import React, { useEffect, useState } from 'react';
import { CircularProgress } from '@mui/material';
import { TokensVService } from '../../services/V3/gozer';
import { I3PayFacFrame } from '../Shared/I3PayFacFrame';
import { handleError } from '../Shared/Functions';

export default function ACHPayment({ errorToast, account, tokenCreateError, setPaymentMethod, submitAch }) {
    const [count, setCount] = useState<number>(0);
    const [url, setUrl] = useState<any>();
    const [tokenId, setTokenId] = useState<string | null>("");
    const [pluginLoading, setPluginLoading] = useState<boolean>(false);

    useEffect(() => {
        if (account && account.id) {
            TokensVService
                .tokensVGetAchUrl(account.id ?? "", {
                    billingAccountId: account.id ?? ""
                })
                .then(url => {
                    setUrl(url);
                }).catch(err => {
                    errorToast(handleError(err))
                });
        }
    }, [account])// eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        // The modal has been Submitted
        if (count === 2) {
            if (tokenId) {
                TokensVService
                    .tokensVCreateAch(account.id ?? "", false, {
                        tokenId: tokenId
                    })
                    .then(tokenExchange => {
                        submitAch(tokenExchange)
                    })
                    .catch(err => {
                        errorToast(handleError(err))
                        tokenCreateError()
                    })
            }

        }
    }, [count])// eslint-disable-line react-hooks/exhaustive-deps

    return <>
        {(count < 1 || pluginLoading) && <div className='loading-container'><CircularProgress className='center-spinner' color="primary" aria-label="Loading" /></div>}
        {!url ? <div /> :
            <>
                <I3PayFacFrame url={url} setCount={setCount} setTokenId={setTokenId} setPaymentMethod={setPaymentMethod} setPluginLoading={setPluginLoading}/>
            </>
        }
    </>
}